// Geo coordinate validation — shared by the admin jobs map (leaflet) and
// anywhere coordinates are plotted. Single source of truth for "is this a
// usable coordinate?".
//
// Rationale (PLAN_admin_portal_phase1.md §2): stored coordinates can be
// null, empty, NaN, literally (0,0) (the "map zooms to the Gulf of Guinea"
// bug — 0 lat/0 lng is a valid number but never a real UK service
// address), or out of range (|lat| > 90 / |lng| > 180). All of those must
// be rejected BEFORE bounds-fitting so one bogus point can't pull the
// viewport to the equator.

export function isValidLat(value) {
  const v = Number(value);
  return Number.isFinite(v) && Math.abs(v) > 0 && Math.abs(v) <= 90;
}

export function isValidLng(value) {
  const v = Number(value);
  return Number.isFinite(v) && Math.abs(v) > 0 && Math.abs(v) <= 180;
}

export function hasValidCoords(lat, lng) {
  return isValidLat(lat) && isValidLng(lng);
}
